import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { ServicesBento } from "../components/home/ServicesBento";
import { Process } from "../components/home/Process";
import { Director } from "../components/home/Director";
import { CtaBand } from "../components/home/CtaBand";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <ServicesBento />
      <Process />
      <Director />
      <CtaBand />
    </main>
  );
}
